import { Modal } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import Cross from '../../../assets/img/icons/cross.svg';
import RoyWhite from '../../../assets/img/icons/royWhite.svg';
import NotificationBG from '../../../assets/img/PassiveNotification.svg';
import Checkbox from './Checkbox';

const ConfirmDialogStyle = styled.div`
  position: relative;
  left: 50%;
  border-radius: 30px;
  background-color: rgba(54, 52, 49, 0.62);
  text-align: center;
  width: 325px;
  transform: translate(-50%, 0);
  z-index: 99999;
  background-image: url(${NotificationBG});
  background-repeat: no-repeat;
  background-size: cover;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    top: ${(props) => (props.inAdvancedSearch ? (props.includeSource ? '40vh' : props.excludeSource ? '8vh' : '62vh') : props.topPercentage)};
    width: 260px;
    border-radius: 21px;
  }
  &.noellipsis {
    width: 400px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 300px;
    }
  }
  svg,
  img {
    width: 105px;
    height: auto;
    margin: 49px 0 25px 0;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 70px;
      margin: 40px 0 18px 0;
    }
    path,
    circle {
      fill: #fff;
    }
  }
  .message {
    color: #fff;
    text-align: center;
    margin: 0 auto;
    font-family: Roboto Slab;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 120% */
    width: 243px;
    display: -webkit-box;
    // -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
    &[noellipsis] {
      -webkit-line-clamp: initial;
      overflow: visible;
      display: block;
      padding: 0 20px;
    }
  }
  .question-message {
    margin-top: 20px;
  }
  .description {
    font-size: 16px;
    font-weight: 400;
    font-family: 'robotoregular';
    text-align: center;
    color: #fff;
    padding: 0 35px;
    line-height: 26px;
    letter-spacing: -0.44px;
    margin-top: 16px;
  }
  .list {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19.906px; /* 142.188% */
    padding: 0 35px;
    margin-top: 12px;
  }
  .confirmation-checkbox {
    display: flex;
    // align-items: center;
    // justify-content: center;
    padding: 0 35px;
    color: #fff;
    font-family: Roboto Slab;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px; /* 114.286% */
    margin-top: 16px;
    .checkbox-wrapper {
      margin: 0 !important;
    }
  }
  hr {
    float: left;
    width: 100%;
    padding: 0;
    margin: 16px 0;
    background: transparent;
  }
  .message-footer {
    border-top: 1px solid rgba(228, 228, 228, 0.26);
    margin: 32px 20px 10px 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    a {
      color: #fff;
      text-align: center;
      font-family: Roboto;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px; /* 118.182% */
      padding: 14px 10px 14px 10px;
      width: 100%;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 18px;
      }
      &:nth-of-type(2) {
        border-left: 1px solid rgba(228, 228, 228, 0.26);
      }
      &:hover,
      &:active,
      &:focus {
        color: #fff;
      }
    }
  }
  &.dialogStyles {
    .message-footer {
      a {
        font-size: 20px;
        @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 16px;
        }
      }
    }
  }
  .close-icon {
    position: absolute;
    width: 32px;
    height: 32px;
    top: 16px;
    margin: 0;
    right: 16px;
    cursor: pointer;
  }
  ${(props) =>
    props.after === true
      ? `
    &::after {
      content: "";
      background-color: rgba(54,52,49,0.2);
      position: absolute;
      top: -30vh;
      right: -130px;
      height: 120vh;
      width: 120vw;
      z-index: -1;
    }
    `
      : ''}
`;

const AudienceDeletePopup = (props) => {
  let {
    icon,
    isCrossIcon,
    title,
    titleQuestion,
    noellipsis,
    descriptions,
    confirm,
    cancel,
    inAdvancedSearch,
    includeSource,
    excludeSource,
    zIndex,
    maxLines,
    topPercentage,
    className,
    list,
    count,
  } = props;
  const [checkBoxChecked, setCheckBocChecked] = useState(false);
  return (
    <StyledModal visible={true} title="" footer={null} closable={false} centered={true}>
      <ConfirmDialogStyle
        inAdvancedSearch={inAdvancedSearch}
        includeSource={includeSource}
        excludeSource={excludeSource}
        className={`${noellipsis} ${zIndex} ${className ? className : ''}`}
        id="confirm-dialog"
        topPercentage={topPercentage}
        maxLines={maxLines}
      >
        {isCrossIcon && <img src={Cross} className="close-icon" alt="close modal" onClick={props.onCancel} />}
        {icon && <img src={icon} alt="icon" />}
        {title && (
          <div className="message" noellipsis={noellipsis}>
            {title}
          </div>
        )}
        {titleQuestion && (
          <div className="message question-message" noellipsis={noellipsis}>
            {titleQuestion}
          </div>
        )}
        {descriptions && <div className="description">{descriptions}</div>}
        {list && (
          <div className="list">
            {list}: {count}
          </div>
        )}
        <div className="confirmation-checkbox">
          <Checkbox value={checkBoxChecked} onClick={() => setCheckBocChecked(!checkBoxChecked)} />
          <span style={{ textAlign: 'left', paddingLeft: '8px' }}>I understand deleting the list will impact the attached components.</span>
        </div>
        {confirm && (
          <div className="message-footer">
            {cancel && <a onClick={props.onCancel}>{props.cancel}</a>}
            {confirm && (
              <a className={checkBoxChecked ? '' : 'disabled'} onClick={props.onConfirm}>
                {props.confirm}
              </a>
            )}
          </div>
        )}
        {!confirm && <hr />}
      </ConfirmDialogStyle>
    </StyledModal>
  );
};

AudienceDeletePopup.defaultProps = {
  icon: RoyWhite,
  isCrossIcon: false,
  title: 'Current curated content will be removed.',
  titleQuestion: 'Are you sure?',
  topPercentage: '50%',
};

export default React.memo(AudienceDeletePopup);

const StyledModal = styled(Modal)`
  .ant-modal-content {
    background: transparent;
    background-clip: padding-box;
    box-shadow: none;
    .ant-modal-header {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      .ant-modal-title {
        margin: 0;
        font-family: 'Roboto';
        color: #424b50;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        word-wrap: break-word;
      }
    }
    /* border-radius: 8px; */
    /* box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.0821427); */
  }
`;
